import { Trans } from 'react-i18next';

import { dateFormatter, Translate } from '@dreryk/react-common';
import { StyledFlex, Text } from '@dreryk/react-components';
import { RecoveryCodesGenerateButton, RecoveryCodesSummaryPanel } from '@dreryk/egabinet-security-frontend';

import { mfaSettingsTranslationKeys } from '../../../../translations';
import { TrustedDevicesTable } from '../trustedDevices/TrustedDevicesTable';

import { ExistingAssociationPanelAssociationDate } from './ExistingAssociationPanelAssociationDate';
import { ExistingAssociationPanelRemoveAssociationButton } from './ExistingAssociationPanelRemoveAssociationButton';

type ExistingAssociationPanelProps = {
   readonly activationDate: Date;
   readonly onAssociationRemoveSuccess: VoidFunction;
};

export const ExistingAssociationPanel = (props: ExistingAssociationPanelProps): JSX.Element => {
   return (
      <StyledFlex direction={'column'} gap={'16px'}>
         <Translate>{mfaSettingsTranslationKeys.yourAccountIsAssociated}</Translate>
         <span>
            <Trans
               i18nKey={mfaSettingsTranslationKeys.associationDateDescription}
               components={{ associationDate: <ExistingAssociationPanelAssociationDate /> }}
               values={{
                  associationDate: dateFormatter(props.activationDate),
               }}
            />
         </span>
         <RecoveryCodesSummaryPanel />
         <StyledFlex direction={'row'} gap={'16px'}>
            <ExistingAssociationPanelRemoveAssociationButton onRemoveSuccess={props.onAssociationRemoveSuccess} />
            <RecoveryCodesGenerateButton />
         </StyledFlex>
         <Text testId={'devicesListDescription'}>
            <Translate>{mfaSettingsTranslationKeys.trustedDeviceTable.trustedDevicesList}</Translate>
         </Text>
         <TrustedDevicesTable />
      </StyledFlex>
   );
};
